import React from 'react'
import DescriptionEditor, {
    normalizeHtml,
    descriptionsAreEqual,
    toQuillHtml,
} from '../../DescriptionEditor/DescriptionEditor'

/** Story map description: story/step links on, mentions off */
const StoryMapDescriptionEditor = (props) => (
    <DescriptionEditor
        {...props}
        enableMentions={props.enableMentions ?? false}
        enableAppLinks={props.enableAppLinks ?? true}
    />
)

export {
    normalizeHtml,
    descriptionsAreEqual,
    toQuillHtml,
}

export default StoryMapDescriptionEditor
